import React, { BaseSyntheticEvent, FC } from 'react';

import { Box, Center } from '@chakra-ui/react';
import { customTheme } from 'theme';

import { CheckmarkIcon, MinusIcon } from 'components/Icons';

interface Props {
  isChecked?: boolean;
  isDisabled?: boolean;
  isIndeterminate?: boolean;
  onClick?(e: BaseSyntheticEvent);
}

export const CustomCheckbox: FC<Props> = props => {
  const { isChecked, isDisabled, isIndeterminate, onClick } = props;
  return (
    // Ignore clicks while disabled.
    <Box onClick={e => !isDisabled && onClick?.(e)}>
      <Box
        borderRadius={8}
        border="1px solid"
        borderColor={
          isChecked || isIndeterminate
            ? 'primary'
            : customTheme.colors.gray[100]
        }
        p="1px"
        cursor={isDisabled ? 'not-allowed' : 'pointer'}
        boxSize="20px"
        bg={isChecked || isIndeterminate ? 'primary' : 'transparent'}
        color={isChecked || isIndeterminate ? 'white' : 'none'}
      >
        {(isChecked || isIndeterminate) && (
          <Center>{isIndeterminate ? <MinusIcon /> : <CheckmarkIcon />}</Center>
        )}
      </Box>
    </Box>
  );
};
